module.exports = __webpack_public_path__ + "49e5fd8f645d667c98acceab879c2da7.MP3";